import { Descriptions } from 'antd';
import { ApplicantUserIdentityDetails, ApplicantUserTermsAndCondition, StaffApplicantProfileIdentityDetailsContactInformationFieldsFragment } from '../../../../generated';
import React from 'react';
import { ApplicantProfileIdentityUploadContainer } from './applicant-profile-identity-upload.container';
import { FormatDate, TERMS_AND_CONDITIONS } from '../../../../constants';
import { useParams } from 'react-router-dom';
import { ProfileHeaderContainer } from './profile-header.container';

interface ApplicantProfileIdentityProps {
  applicantId: string;
  contactDetails: StaffApplicantProfileIdentityDetailsContactInformationFieldsFragment;
  identityDetails: ApplicantUserIdentityDetails;
  termsAndConditions: ApplicantUserTermsAndCondition[];
  onEdit: () => void;
}

export const ApplicantProfileIdentity: React.FC<ApplicantProfileIdentityProps> = ({ applicantId, identityDetails, termsAndConditions, contactDetails, onEdit }) => {
  let genderLabel = '';
  if (identityDetails.gender === 'M') {
    genderLabel = 'Male';
  } else if (identityDetails.gender === 'F') {
    genderLabel = 'Female';
  } else {
    genderLabel = 'Other';
  }

  const params = useParams();

  return (
    <div className="flex flex-col space-y-4">
      <ProfileHeaderContainer title="Identity" onEdit={onEdit} />
      <div>
        <Descriptions title={undefined} layout="vertical" size="small" column={2} className="w-[450px]">
          <Descriptions.Item label="Applicant ID">{applicantId}</Descriptions.Item>
          <Descriptions.Item label="">&nbsp;</Descriptions.Item>
          <Descriptions.Item label="Last Name (Surname/Family Name)">{identityDetails.lastName}</Descriptions.Item>
          <Descriptions.Item label="Rest of Name">{identityDetails.restOfName}</Descriptions.Item>
          <Descriptions.Item label="Generational Suffix">{identityDetails.generationalSuffix ?? "N/A"}</Descriptions.Item>
          <Descriptions.Item label="Gender">{genderLabel}</Descriptions.Item>
          <Descriptions.Item label="Date of Birth">{FormatDate(identityDetails.dateOfBirth)}</Descriptions.Item>
          <Descriptions.Item label="Email Address">{contactDetails.emailAddress}</Descriptions.Item>
        </Descriptions>
      </div>
      <ApplicantProfileIdentityUploadContainer applicantId={params.applicantId || ''} />
      <div className="flex space-x-48 w-1/2">
        <div>
          <Descriptions title="" layout="vertical" size="small" column={1} className="w-[400px]">
            {termsAndConditions?.map((doc: ApplicantUserTermsAndCondition) => (
              <React.Fragment key={doc.id}>
                <br />
                <Descriptions.Item label={`Version: ${doc.version} Affirmed: ${FormatDate(doc.attestedAt)}`}>
                  {TERMS_AND_CONDITIONS.find((t) => t.key === doc.acceptanceOf)?.descriptions}
                </Descriptions.Item>
              </React.Fragment>
            ))}
          </Descriptions>
        </div>
      </div>
    </div>
  );
};
